<template>
    <div>
    	<img src="../assets/img/detail/gbw/1.jpg" width="100%" />
    	<img src="../assets/img/detail/gbw/2.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/3.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/4.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/5.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/6.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/7.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/8.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/9.jpg" width="100%"/>
    	<img src="../assets/img/detail/gbw/10.jpg" width="100%"/>
		<img src="../assets/img/detail/gbw/11.jpg" width="100%"/>
    </div>
</template>

<script>
    export default {
        name: 'Product_sswm',
        data: function () {
            return {
            }
        },
        mounted: function () {

        },
        created: function () {

        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>